module.exports = __webpack_public_path__ + "static/media/icon_itsuki317fd86ff333015e8fa4ad3f9a762b11.webp";